<template>
    <div
        class="q-mt-md"
    >
        <table
            class="left-grey-table"
        >
            <tbody>
                <tr
                    v-for="data in props.tableData"
                    :key="data"
                >
                    <td
                        v-if="data.fullWidth"
                        colspan="2"
                    >
                        <div class="q-mt-sm">
                            {{ data.header }}
                            <span
                                v-if="data.fullWidthExtraCondition"
                                class="warn-area"
                            >
                                <i class="fa-solid fa-exclamation-triangle" />
                                {{ data.extraContent }}
                            </span>
                            <span
                                v-if="data.help"
                                class="mdi mdi-alert-circle-outline q-mr-md cursor-pointer"
                                data-cy="full-width-modal"
                                @click="emit('openHelpModal', data.helpType)"
                            />
                        </div>
                    </td>
                    <td
                        v-if="!data.fullWidth"
                        class="grey-lighter-background"
                    >
                        {{ data.header }}
                        <span
                            v-if="data.help"
                            class="mdi mdi-alert-circle-outline q-mr-md cursor-pointer"
                            data-cy="null-width-modal"
                            @click="emit('openHelpModal', data.helpType)"
                        />
                    </td>
                    <td
                        v-if="!data.fullWidth"
                    >
                        <div
                            class="unit-aligned-row"
                            :data-cy="`${data.id}-value`"
                        >
                            <slot :name="data.id" />
                            <div
                                v-if="data.value === 'FloodHub'"
                                class="value"
                            >
                                <a
                                    href="https://sites.research.google/floods"
                                    target="_blank"
                                >
                                    Google FloodHub
                                </a>
                            </div>
                            <div
                                v-else
                                class="value"
                            >
                                {{ data.value }}
                            </div>
                            <div
                                v-for="row in data.extraContent"
                                :key="row"
                            >
                                {{ row }}
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
const props = defineProps({
    tableData: {
        type: Array,
        default: () => []
    },
})
const emit = defineEmits(['openHelpModal'])
</script>

<style lang="scss">
.warn-area {
    background-color: red;
    color: white;
    border-radius: 0.5em;
    font-weight: bold;
    padding: 0.3em;
}
.unit-aligned-row {
    display: flex;

    .value {
        margin-left: 0.5em;
    }
}
</style>
